var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 30 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 .333a8.334 8.334 0 1 0 0 16.668A8.334 8.334 0 0 0 15 .333m0 13.334a5 5 0 1 1 0-10 5 5 0 0 1 0 10M30 32v-1.667a11.667 11.667 0 0 0-11.667-11.666h-6.666A11.667 11.667 0 0 0 0 30.333V32h3.333v-1.667A8.333 8.333 0 0 1 11.667 22h6.666a8.333 8.333 0 0 1 8.334 8.333V32z"
  })));
};
export default SvgPerson;